var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "translate(0.114258 0.114441)",
    d: "M23.65663 0.34327728C24.114326 0.80098027 24.114326 1.5430635 23.65663 2.0007665L13.657 12L23.65663 21.999388C23.991869 22.334543 24.092171 22.838661 23.910751 23.276615C23.729334 23.714569 23.301933 24 22.827896 24C22.51701 24.000418 22.218769 23.876938 21.999165 23.656876L12 13.657L2.0008357 23.656876C1.7812314 23.876938 1.4829911 24.000418 1.1721032 24C0.698066 24 0.27066642 23.714569 0.089248322 23.276615C-0.092169777 22.838661 0.0081315236 22.334543 0.34337056 21.999388L10.343 12L0.34337056 2.0007665C-0.11432578 1.5430635 -0.11432578 0.80098027 0.34337056 0.34327728C0.80106694 -0.11442576 1.5431393 -0.11442576 2.0008357 0.34327728L12 10.343L21.999165 0.34327728C22.456861 -0.11442576 23.198933 -0.11442576 23.65663 0.34327728Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.23ea1a36f7281bd0d2d4c4b3d50c23bf.svg";
export { ForwardRef as ReactComponent };